import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BlockEmployeeSliceType = {
  actions: {
    name:
      | 'CHANGE_SIP_EMPLOYEE'
      | 'CHANGE_LEAD_EMPLOYEE'
      | 'CHANGE_TASK_EMPLOYEE'
      | 'CHANGE_CONTRACT_EMPLOYEE'
      | 'CHANGE_TRIGGER_RESULT_EMPLOYEE'
      | 'CHANGE_TRIGGER_CONDITION_EMPLOYEE'
      | null;
    status: 'DONE' | 'IN_PROGRESS' | 'CANCELED' | 'ERROR' | null;
  }[];
  isSubmit?: boolean;
};

const initialState: BlockEmployeeSliceType = {
  actions: [],
  isSubmit: false
};

const blockEmployeeSlice = createSlice({
  name: 'block-employee-slice',
  initialState,
  reducers: {
    setBlockEmployeeAction: (state, action: PayloadAction<BlockEmployeeSliceType['actions'][number]>) => {
      if (state.actions?.some(({ name }) => name === action.payload.name)) {
        state.actions = state.actions?.map(item =>
          item?.name === action?.payload?.name
            ? {
                ...item,
                ...action.payload
              }
            : item
        );
      } else {
        state.actions = [...(state.actions || []), action.payload];
      }
    },
    setClearBlockEmployeeActions: state => {
      state.actions = [];
      state.isSubmit = false;
    },
    setBlockEmployeeIsSubmit: (state, action: PayloadAction<boolean>) => {
      state.isSubmit = action.payload;
    }
  }
});

export const { setBlockEmployeeAction, setClearBlockEmployeeActions, setBlockEmployeeIsSubmit } =
  blockEmployeeSlice.actions;
export const blockEmployeeReducer = blockEmployeeSlice.reducer;
